/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

//CREATING A DATA SLICE
const ckackrSlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "ckackr",

  //STATE PROPERTIES INCLUDED IN THIS SLICE
  initialState: {
    //CKA_CAR - EDUCATION
    isEducationQualified: "",
    eduFields: "",
    educationInstitute: "",

    //CKA_CAR - QUALIFICATION
    isFinanceQualified: "",
    financeEducationInstitute: "",

    //CKA_CAR - INVESTMENT EXPERIENCE
    isExperiencedInvestor: "",
    investedProducts: "",
    investmentInstitute: "",

    //CKA_CAR - WORK EXPERIENCE
    isWorkExperienced: "",
    experienceType: "",
    workOrganisationName: "",

    result: {
      isCkaPass: "",
      isCarPass: "",
    },
  },

  //REDUCERS INSIDE EACH SLICE DECLARATION CAN PERFORM ACTION ON EACH DATA STATES
  reducers: {
    updateCKACKR: (state, action) => {
      const actionType = action.payload.type;
      const data = action.payload.payload;

      switch (actionType) {
        case "education":
          state.isEducationQualified = data.isEducationQualified;
          state.eduFields = data.eduFields;
          state.educationInstitute = data.educationInstitute;
          break;

        case "professional":
          state.isFinanceQualified = data.isFinanceQualified;
          state.financeEducationInstitute = data.financeEducationInstitute;
          break;

        case "investment":
          state.isExperiencedInvestor = data.isExperiencedInvestor;
          state.investedProducts = data.investedProducts;
          state.investmentInstitute = data.investmentInstitute;
          break;

        case "experience":
          state.isWorkExperienced = data.isWorkExperienced;
          state.experienceType = data.experienceType;
          state.workOrganisationName = data.workOrganisationName;
          break;

        case "result":
          state.result = data;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const { updateCKACKR } = ckackrSlice.actions;

export default ckackrSlice.reducer;
